// @flow
/* -----------------Globals--------------- */
import React from 'react';

/* -----------------UI--------------- */
import {
  Paper,
  Box,
  Container,
} from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { withStyles } from '@material-ui/core/styles';
import IconSkeleton from './IconSkeleton';
/* -----------------Type declarations--------------- */
type Classes = {
  listItem: string,
  centeredMobile: string,
  fab: string,
  tabs: string,
};

/* -----------------Props--------------- */
type Props = {
  classes: Classes,
  showTabs: ?boolean,
  showFab: ?boolean, // This would be false on smart folders
  showDescription: ?boolean, // This would be false on profile
  showBreadcrumbs: ?boolean, // This would be false on profile
  numIcons: Number, // This would be 1 on profile, 0 on smart folders
};

/* -----------------Styles--------------- */
const styles = theme => ({
  listItem: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  centeredMobile: {
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      width: '100%',
    },
  },

  fab: {
    borderRadius: 24,
    height: 48,
    width: 144,
  },
  tabs: {
    [theme.breakpoints.down('sm')]: {
      height: 32,
    },
  },
});

// Paper component should = 288

/* -----------------Component--------------- */
const AppContentHeaderSkeleton = (props: Props) => {
  const {
    classes,
    showFab = true,
    showDescription = true,
    showBreadcrumbs = true,
    showTabs = false,
    numIcons = 3,
  } = props;

  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));
  // TODO: Refactor this into its own component, in case the breadcrumbs load slower cc/ @nitesh
  const AppContentHeaderToolbarSkeleton = () => (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      height={56}
      width="100%"
    >
      <Box flexGrow={1}>
        {showBreadcrumbs
          ? (
            <Skeleton
              variant="text"
              width={100}
              animation="wave"
            />
          ) : null
           }
      </Box>
      <Box display="flex">
        {[...Array(numIcons).keys()].map(num => <IconSkeleton key={num} />)}
      </Box>
    </Box>

  );
  const LearningContentHeroSkeleton = () => (
    <Box py={2} pb={3}>
      <Box
        className={classes.listItem}
        pb={isMobile ? 0 : 2}
        display="flex"
        width="100%"
      >
        <Box
          mr={isMobile ? 0 : 3}
        >
          <Skeleton
            variant="circle"
            width={88}
            height={88}
          />
        </Box>
        <Box
          className={classes.centeredMobile}
          display="flex"
          flexDirection="column"
          justifyContent="center"
          width="100%"
          py={1}
        >
          <Box
            mt={isMobile ? 1 : 0}
            mb={isMobile ? 0 : 1}
          >
            <Skeleton
              variant="text"
              width={300}
              height={34}
              animation="wave"
            />
          </Box>
          <Skeleton
            variant="text"
            width={200}
            height={20}
            animation="wave"
          />
        </Box>
      </Box>
      {showDescription
        ? (
          <Box
            className={classes.centeredMobile}
            maxWidth="100%"
            width="500px"
            mt={isMobile ? 1 : 0}
          >
            <Skeleton
              variant="text"
              height={24}
              width="100%"
              animation="wave"
            />
          </Box>
        ) : null
      }
      {showFab
        ? (
          <Box
            className={classes.centeredMobile}
            pt={2}
          >
            <Skeleton
              classes={{ root: classes.fab }}
              variant="rect"
            />
          </Box>
        ) : null
      }
      {showTabs ? <Box height="24px" className={classes.tabs} /> : null}
    </Box>
  );
  return (
    <Paper elevation={0} square>
      <Container maxWidth="lg">
        <AppContentHeaderToolbarSkeleton />
        <LearningContentHeroSkeleton />
      </Container>
    </Paper>
  );
};

export default withStyles(styles)(AppContentHeaderSkeleton);
